// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => (chunkId + "." + {"7827":"34b57fb02ed227da2bb6","9388":"c24754195835fc057d34"}[chunkId] + ".css");